module.exports = function () {

    $('form[data-wffm] select').each(function () {
        if (!$(this).attr('size')) {
            $(this).wrap('<div class="select-wrapper"></div>');
        }
    });

    $('form[data-wffm] .datepicker').each(function () {
        $(this).attr('readonly', 'readyonly');
    });

    var originalSubmitText = '';
    var submittedData = {};

    $('form[data-wffm]').on('wffm.formsubmitsuccess',
        function () {
            $(this).removeClass('wffm-submitting');

            dataLayer.push({
                event: 'formSubmissionSuccess',
                formName: $('h1').text(),
                data: submittedData
            });
        });

    $('form[data-wffm]').on('wffm.formsubmiterror',
        function () {
            var $button = $(this).find('input[type=submit]');

            $button.val(originalSubmitText);
            $button.removeClass('btn-submitting');
            $(this).removeClass('wffm-submitting');

            dataLayer.push({
                event: 'formSubmissionError',
                formName: $('h1').text(),
                data: submittedData
            });
        });

    $('form[data-wffm]').on('wffm.formsubmitbegin',
        function () {
            var $button = $(this).find('input[type=submit]');

            originalSubmitText = $button.val();

            $button.val('Sending...');
            $button.addClass('btn-submitting');
            $(this).addClass('wffm-submitting');

            var initialData = $('form[data-wffm]').serializeArray();
            var dataIds = {};
            var dataValues = {};

            initialData.forEach(function (elem) {
                var r = /Sections\[(\d+)\](.*)Fields\[(\d+)\]\.(.*)/g;
                var a = r.exec(elem.name);
                if (a) {
                    var section = a[1];
                    var field = a[3];
                    var type = a[4];

                    if (type === 'Id') {
                        dataIds[section + ',' + field] = elem.value.toLowerCase().replace(/[^a-z0-9]/g, '');
                    }
                    else if (type === 'Value') {
                        dataValues[section + ',' + field] = elem.value;
                    }
                }
            });

            Object.keys(dataIds).forEach(function (key) {
                submittedData[dataIds[key]] = dataValues[key];
            });
        });
};